import { ClaimDischargeDto } from "@libs/gateways/acc/AccGateway.dtos.ts";
import { Model } from "@libs/models/Model.ts";
import { IRootStore } from "@shared-types/root/root-store.interface.ts";

export class ClaimDischarge extends Model<ClaimDischargeDto> {
  constructor(
    private root: IRootStore,
    dto: ClaimDischargeDto
  ) {
    super(dto);
  }

  get claimId() {
    return this.dto.claimId;
  }

  get businessRole() {
    return this.dto.businessRole;
  }

  get discharge() {
    return this.dto.discharge;
  }
}
